module.exports = __webpack_public_path__ + "img/success-apply.32bf3dca.png";